import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { getLpSuppliers } from '../services/MasterDataRepository';
import MBAutocomplete from '../../../shared/components/mbui/MBAutocomplete';

/**
 * @type {React.FC<import("./types").PortOperatorAutocompleteProps>}
 */
const PortOperatorAutocomplete = ({
  value,
  onPortOperatorChange = () => undefined,
  name = 'portOperator',
  label = 'Port Operator',
  required = false,
  index,
  isPortOperator = true,
}) => {
  const [portOperatorOptions, setPortOperatorOptions] = useState([]);

  useEffect(() => {
    const fetchPortOperators = async () => {
      try {
        const params = { isPortOperator: isPortOperator };
        const portOperatorData = await getLpSuppliers(params);
        const options = portOperatorData
          .map((v) => ({
            label: v.supplierName,
            value: v.supplierNo,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setPortOperatorOptions(options);
      } catch (error) {
        console.error('Error fetching port operators:', error);
      }
    };
    fetchPortOperators();
  }, [isPortOperator]);

  const onChange = (e) => {
    index ? onPortOperatorChange(e, index) : onPortOperatorChange(e);
  };

  return (
    <MBAutocomplete
      options={portOperatorOptions}
      getOptionLabel={(option) =>
        typeof option === 'object' && option !== null ? option.label : ''
      }
      isOptionEqualToValue={(option, value) => option.value === value.value}
      value={
        portOperatorOptions.find((option) => option.value === value) || null
      }
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          size='small'
          placeholder='Select Port Operator'
          required={required}
          label={label}
        />
      )}
    />
  );
};

export default PortOperatorAutocomplete;
